import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { State } from '@store/reducer';
import { Selector } from 'react-redux';

import { DesktopState } from './desktop.state';

export const selectDesktopState: Selector<State, DesktopState> = (state: State) => state.desktop;

export const selectDesktopSettings: Selector<State, DesktopSettings> = (state: State) =>
  state.desktop.settings;

export const selectDesktopIsLoadingSettings: Selector<State, boolean> = (state: State) =>
  state.desktop.loadingSettings;

export const selectDesktopUsernameSettings: Selector<State, string> = (state: State) =>
  state.desktop.settings.username;

export const selectDesktopSsoConnectionSettings: Selector<State, string> = (state: State) =>
  state.desktop.settings.ssoConnection;
